export default __webpack_public_path__ + "img/cGFvMdBz.3d35f773.svg";